<script setup>
import {onMounted, ref} from "vue";
import {displaysMaxValues} from "@/config";

const periodConstants = displaysMaxValues.display.refreshPeriod;

const emit = defineEmits(['onChange'])
const props = defineProps(['initialDuration'])

const duration = ref(null)

onMounted(() => {
  duration.value = props.initialDuration
})

const incrementPeriod = (value) => {
  const current = Number.parseInt(duration.value);

  // duration is set
  if (duration.value) {
    if (value === -1 && current === 1) {
      duration.value = null;
    } else {
      const isAboveMin = value > 0 ? current >= periodConstants.min : current > periodConstants.min;
      duration.value = isAboveMin
          ? Math.min(current + value, periodConstants.max)
          : periodConstants.min;
    }
  } else {
    // duration is null
    duration.value = value === 1 ? 1 : null;
  }

  emit('onChange', { value: duration.value });
};

const changePeriod = (value) => {
  duration.value = value
  emit('onChange',{ value : Number.parseInt(duration.value) })
}

const period_rule = (value) => {
  if(value){
    const val = Number.parseInt(value);
    return (
        (val && val >= periodConstants.min && val <= periodConstants.max) ||
        `Zadejte číslo od ${periodConstants.min} do ${periodConstants.max}`
    );
  } else {
    return true
  }
};
</script>

<template>
  <v-text-field
      :model-value="duration"
      type="number"
      id="display-period"
      label="Počet vteřin"
      append-icon="add"
      prepend-icon="remove"
      @click:append="() => incrementPeriod(1)"
      @click:prepend="() => incrementPeriod(-1)"
      @update:model-value="(value) => changePeriod(value)"
      :max="periodConstants.max"
      :min="periodConstants.min"
      :rules="[period_rule]"
  />
</template>

<style scoped>

</style>